/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: calendar-field.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/app/shared/field-viewer/calendar-field.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 09/03/26, 10:14;
 *  Updated at: 09/03/26, 10:14;
 *  ```
 */


import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';


import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';

import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {environment} from "../../../environments/environment";
import {CampoAggiuntivo, CampoUtility} from "../models/campo-aggiuntivo";
import {ActionButton} from "../_services/dynamic-crud.service";
import {ApiPathsService} from "../../api-paths.service";
import {ToastrService} from "ngx-toastr";
import {Subject} from "rxjs";
import {generateExcel} from "../../../environments/Utility/Utility";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-calendar-field',
  template: `
    <div [ngStyle]="campo.style"
         *ngIf=" campoUtility.Show(campo, Oggetto, campo.modificabile, null, CampiNascosti ?? [])">
      <label [class]="campo.titleClass" [ngStyle]="campo.titleStyle"
             *ngIf=" !campo.titledivClass && !hideLabel">{{
          campo.nome
            | translate
        }}
        <app-tooltip-icon [campo]="campo"></app-tooltip-icon>
      </label>

      <div class="card-body">
        <!-- ============================================================== -->
        <!-- Top Buttons -->
        <!-- ============================================================== -->
        <div class="d-md-flex align-items-center bg-white">
          <!--            <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>-->

        </div>
        <button class="btn btn-outline-primary " *ngIf="campo['stampa']" (click)="Stampa()">
          Export Excel
        </button>

        <!--    <h3>-->
        <!--      {{Title}}-->
        <!--      <button class="btn btn-outline-primary " *ngIf="Modificabile" (click)="addEvent()">-->
        <!--        {{AddButtonText}}-->
        <!--      </button>-->
        <!--      <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>-->
        <!--      <div class="clearfix"></div>-->
        <!--    </h3>-->

        <hr>

        <div class="pt-3 row">
          <div class="col-md-4">
            <div class="btn-group">
              <div class="btn btn-success" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                   (viewDateChange)="DateChange()">
                Previous
              </div>
              <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate"
                   (viewDateChange)="DateChange()"> Today
              </div>
              <div class="btn btn-info" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                   (viewDateChange)="DateChange()">
                Next
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'it' }}</h3>
          </div>
          <div class="col-md-4 text-right">
            <div class="btn-group">
              <div class="btn btn-info" (click)="setView(CalendarView.Month)"
                   [class.active]="view === CalendarView.Month"> Month
              </div>
              <div class="btn btn-success" (click)="setView(CalendarView.Week)"
                   [class.active]="view === CalendarView.Week"> Week
              </div>
              <div class="btn btn-warning" (click)="setView(CalendarView.Day)"
                   [class.active]="view === CalendarView.Day"> Day
              </div>
            </div>
          </div>
        </div>
        <br>
        <!-- ============================================================== -->
        <!-- Calander Area -->
        <!-- ============================================================== -->
        <div [ngSwitch]="view">
          <mwl-calendar-month-view
            *ngSwitchCase="CalendarView.Month"
            [viewDate]="viewDate"
            [events]="getEvents()"
            [refresh]="refresh"
            [activeDayIsOpen]="activeDayIsOpen"
            (dayClicked)="dayClicked($event.day)"
            (eventClicked)="handleEvent('Clicked', $event.event)"
            (eventTimesChanged)="eventTimesChanged($event)"
          >
          </mwl-calendar-month-view>
          <mwl-calendar-week-view
            *ngSwitchCase="CalendarView.Week"
            [viewDate]="viewDate"
            [events]="getEvents()"
            [refresh]="refresh"
            (eventClicked)="handleEvent('Clicked', $event.event)"
            (eventTimesChanged)="eventTimesChanged($event)"
          >
          </mwl-calendar-week-view>
          <mwl-calendar-day-view
            *ngSwitchCase="CalendarView.Day"
            [viewDate]="viewDate"
            [events]="getEvents()"
            [refresh]="refresh"
            (eventClicked)="handleEvent('Clicked', $event.event)"
            (eventTimesChanged)="eventTimesChanged($event)"
          >
          </mwl-calendar-day-view>
        </div>
        <br/><br/>
        <hr>
        <br/>
      </div>

    </div>
  `
})
export class CalendarFieldComponent implements OnInit {
  @Input() campo: CampoAggiuntivo;
  @Input() Oggetto: any;
  @Output() OggettoChange = new EventEmitter();
  @Input() CampiNascosti;
  @Input() DropdownSources: any = {};
  @Output() DropdownSourcesChange = new EventEmitter();
  @Input() Padre: any;
  @Output() PadreChange = new EventEmitter();
  @Output() CustomButton = new EventEmitter();
  @Output() refresh = new EventEmitter();
  @Input() hideLabel: boolean;

  //calendar
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  activeDayIsOpen: boolean = true;
  modalData!: {
    action: string;
    event: CalendarEvent;
  };

  //endCalendar

  constructor(
    public campoUtility: CampoUtility,
    public apiPaths: ApiPathsService,
    public toastService: ToastrService,
    private datepipe: DatePipe,
  ) {
  }

  env = environment;

  ngOnInit() {
  }

  getEvents(): any[] {
    if (this.campo.source && Array.isArray(this.campo.source)) {
      return this.campo.source??[]
    } else if (this.campo.oggetti?.length && this.Oggetto[this.campo.oggetti[0]]) {
      return this.campo.oggetti.reduce((array, child) => [...array, ...this.Oggetto[child]], [])??[]
    } else if (this.campo.source && !Array.isArray(this.campo.source)) {
      return (this.DropdownSources ? this.DropdownSources[this.campo.source] : undefined)??[]
    }else return [];
  }

  customButton(oggetti, button: ActionButton) {
    if (button.func)
      button.func(this.Oggetto, this.apiPaths, () => {
      }, this.toastService)
    else
      this.CustomButton.emit(button);
  }

  customAction(oggetti, button) {
    this.CustomButton.emit(button);
  }

  dayOfMonth(month: number) {
    if ([10, 3, 5, 8].includes(month)) return 30
    if ([1].includes(month)) return 28;
    return 31
  }
  isDateInDay(date, day) {
    const start = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0);
    const end   = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999);

    return date >= start && date <= end;
  }
  Stampa() {
    var firstDay = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
    var offset = firstDay.getDay();
    var data = [["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],[]];
    var idx = 1;
    for (let i = 0; i < offset; i++) {
      data[1].push('');
    }

    for (let i = 1; i <= this.dayOfMonth(firstDay.getMonth()); i++) {
      var currentDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), i);
      if (data.length < idx + 1)
        data.push([]);
      var TestoCella = this.getEvents().filter(x=>this.isDateInDay(x.start, currentDate))?.reduce((acc, x) => {
        return acc + x.title + "\n";
      }, "");
      data[idx].push(TestoCella);
      if (currentDate.getDay() == 6) {
        idx++;
      }
    }
    generateExcel(data, `${this.datepipe.transform(firstDay, 'MMMM')} ${firstDay.getFullYear()}`);

  }

  //region calendar
  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  dayClicked({date, events}: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
    //this.onDayClick.emit(events);
  }

  DateChange() {
    //this..emit(this.viewDate);
    this.activeDayIsOpen = false;
  }

  eventTimesChanged({
                      event,
                      newStart,
                      newEnd,
                      type,
                    }: CalendarEventTimesChangedEvent): void {
    // this.events = this.events.map((iEvent) => {
    //   if (iEvent === event) {
    //     return {
    //       ...event,
    //       start: newStart,
    //       end: newEnd,
    //     };
    //   }
    //   return iEvent;
    // });
    // this.handleEvent('Dropped or resized', event);
    this.toastService.warning("Questa operazione non è stata Ancora implementata");
    console.error("eventTimesChanged: not implemented")
  }

  handleEvent(action: string, event: CalendarEvent): void {
    // if (action == 'Clicked')
    //   this.onClick.emit(event);
    // if (action == 'Edit')
    //   this.onEditClick.emit(event);
    // if (action == 'Deleted')
    //   this.onDeleteClick.emit(event);
    // this.modalData = { event, action };
    // this.modal.open(this.modalContent, { size: 'lg' });
  }

  //endregion
}
